import React, { useEffect, useState } from "react";
import './styles.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import { isLoggedInUserBusiness, isLoggedInUserEmployee, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { useSelector } from 'react-redux'
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";

const PayrollMenu = props => {
    let navigate = useNavigate();
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.PAYROLL, PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.PAYROLL, PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL, employeeSelectedBusiness, employeeSelectedLocation)
        }

    }

    const MENU_OPTIONS = [
        ...(isLoggedInUserEmployee(user) ? [{ key: 'PAYSLIP', value: removeSpecialCharAndChangeToPascal('PAYSLIP') }] : []),
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES) ? [{ key: 'TAX_RULES', value: removeSpecialCharAndChangeToPascal('TAX_RULES') }] : []),
        ...(isPermissionAllowed(PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL) ? [{ key: 'EMPLOYEE_PAYROLL', value: removeSpecialCharAndChangeToPascal('EMPLOYEE_PAYROLL') }] : []),
    ]

    const handleOptionClick = item => {
        switch (item.key) {
            case 'PAYSLIP':
                navigate(ROUTES.payroll.payslipList, {
                    state: {
                        fromRoute: 'payrollMenu',
                        employeeId: user.data.userDetails.employeeId
                    }
                })
                break
            case 'TAX_RULES':
                navigate(ROUTES.payroll.taxRules)
                break
            case 'EMPLOYEE_PAYROLL':
                navigate(ROUTES.employee.list, {
                    state: {
                        routeType: 'payslipList',
                        flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.PAYSLIP_LIST
                    }
                })
                break
            default:
                break
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Select Option' />
                <div className="pms-option-list-container">
                    {MENU_OPTIONS.map(item => (<div className="pms-ol-item-container" onClick={() => { handleOptionClick(item) }}>
                        <h5 className="pms-oli-label">{item.value}</h5>
                        <div className="pms-oli-img-container">
                            <img src={require('../../../assets/ic_right_icon.png')} className="img" alt="img" />
                        </div>
                    </div>))}
                </div>
            </CommonScreenContent>
        </>
    )
}

export default PayrollMenu